__turbopack_context__.v({
  "i": "baseIcon-module-scss-module__BMf-ga__i",
  "size10": "baseIcon-module-scss-module__BMf-ga__size10",
  "size12": "baseIcon-module-scss-module__BMf-ga__size12",
  "size14": "baseIcon-module-scss-module__BMf-ga__size14",
  "size16": "baseIcon-module-scss-module__BMf-ga__size16",
  "size18": "baseIcon-module-scss-module__BMf-ga__size18",
  "size20": "baseIcon-module-scss-module__BMf-ga__size20",
});
